import platform from "../../../util/platform";
const getOverview = (appHost) => {
    return (params) => {
        const path = `/app/hostname/${appHost}/overview`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const updateSettings = (settings) => {
    return (params) => {
        const path = `/app/config/update`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, settings);
    };
};
const updateBrandingSettings = (brandingSettings) => {
    return (params) => {
        const path = `/app/config/update/branding`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, brandingSettings);
    };
};
const updateSecuritySettings = (securitySettings) => {
    return (params) => {
        const path = `/app/config/update/security`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, securitySettings);
    };
};
const updateLandingSettings = (landingSettings) => {
    return (params) => {
        const path = `/app/config/update/landing`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, landingSettings);
    };
};
const updateUserSettings = (userSettings) => {
    return (params) => {
        const path = `/app/config/update/user`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, userSettings);
    };
};
const updateContentSettings = (contentSettings) => {
    return (params) => {
        const path = `/app/config/update/content`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, contentSettings);
    };
};
const updateContentSettings_CreateModuleType = (moduleType) => {
    return (params) => {
        const path = `/app/config/update/content/module-type`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, moduleType);
    };
};
const updateContentSettings_UpdateModuleType = (moduleTypeId, moduleType) => {
    return (params) => {
        const path = `/app/config/update/content/module-type/${moduleTypeId}`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, moduleType);
    };
};
const updateContentSettings_DeleteModuleType = (moduleTypeId) => {
    return (params) => {
        const path = `/app/config/update/content/module-type/${moduleTypeId}/delete`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, {});
    };
};
const updateCohortGroupSettings = (cohortGroupSettings) => {
    return (params) => {
        const path = `/app/config/update/cohort-settings`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, cohortGroupSettings);
    };
};
const updateCohortGroupSettings_CreateCohortGroup = (cohortGroup) => {
    return (params) => {
        const path = `/app/config/update/cohort-settings/create/cohort-group`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, cohortGroup);
    };
};
const updateCohortGroupSettings_DeleteCohortGroup = (cohortGroupId) => {
    return (params) => {
        const path = `/app/config/update/cohort-settings/delete/cohort-group/${cohortGroupId}`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, {});
    };
};
const updateCohortGroupSettings_UpdateCohortGroup = (cohortGroupId, cohortGroup) => {
    return (params) => {
        const path = `/app/config/update/cohort-settings/update/cohort-group/${cohortGroupId}`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, cohortGroup);
    };
};
const updateCohortGroupSettings_CreateCohortForGroup = (cohortGroupId, cohort) => {
    return (params) => {
        const path = `/app/config/update/cohort-settings/create/cohort-group/${cohortGroupId}/cohort`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, cohort);
    };
};
const updateCohortGroupSettings_DeleteCohortForGroup = (cohortGroupId, cohortId) => {
    return (params) => {
        const path = `/app/config/update/cohort-settings/delete/cohort-group/${cohortGroupId}/cohort/${cohortId}`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, {});
    };
};
const updateCohortGroupSettings_UpdateCohortForGroup = (cohortGroupId, cohortId, cohort) => {
    return (params) => {
        const path = `/app/config/update/cohort-settings/update/cohort-group/${cohortGroupId}/cohort/${cohortId}`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, cohort);
    };
};
const appConfig = {
    getOverview,
    updateSettings,
    updateBrandingSettings,
    updateSecuritySettings,
    updateLandingSettings,
    updateUserSettings,
    updateContentSettings,
    updateContentSettings_CreateModuleType,
    updateContentSettings_UpdateModuleType,
    updateContentSettings_DeleteModuleType,
    updateCohortGroupSettings,
    updateCohortGroupSettings_CreateCohortGroup,
    updateCohortGroupSettings_DeleteCohortGroup,
    updateCohortGroupSettings_UpdateCohortGroup,
    updateCohortGroupSettings_CreateCohortForGroup,
    updateCohortGroupSettings_DeleteCohortForGroup,
    updateCohortGroupSettings_UpdateCohortForGroup,
};
export default appConfig;
